export interface AnalyticsByUnspsc {
  historicalTimeframe: Timeframe;
  forecastTimeframe: Timeframe;
  analytics: UnspscAnalytics[];
}

interface Timeframe {
  start: {
    year: number;
    month: number;
  };
  end: {
    year: number;
    month: number;
  };
}

export interface UnspscAnalytics {
  spendDollarsAmount: number;
  unitCountPurchased: number;
  unspsc: {
    id: number;
    name: string;
  };
  historicalspend: Spend;
  forecastSpend: Spend;
}

interface Spend {
  spendDollarAmount: UnspscSpendMonth[];
  unitCountPurchased: UnspscSpendMonth[];
}

export interface UnspscSpendMonth {
  year: number;
  month: number;
  marketShare: number;
  total: number;
  spendWithSeller: number;
}

export default class EnhancedAnalyticsService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/enhancedanalytics/';

  constructor(private $http) {
    'ngInject';
  }

  byBuyer(agreementId, buyerId?) {
    return this.$http.get(`${this.baseUrl}bybuyer`, {
      params: {
        agreementId,
        buyerId
      }
    });
  }

  byCompetitor(agreementId) {
    return this.$http.get(`${this.baseUrl}bycompetitor`, {
      params: {
        agreementId
      }
    });
  }

  facilities(agreementId) {
    return this.$http.get(`${this.baseUrl}facilities`, {
      params: {
        agreementId
      }
    });
  }

  byMonth(agreementId, buyerId?) {
    return this.$http.get(`${this.baseUrl}bymonth`, {
      params: {
        agreementId,
        buyerId
      }
    });
  }

  /**
   *
   * @param agreementId
   * @param buyerId
   * @param sellerId - Null means "me". Basically, tell me about my products. Zero means "all". Tell me about all my
   * competitors. And any other value should be the ID of a specific competitor to get their product information.
   * @param facilityId
   * @returns {any}
   */
  byProduct(agreementId, buyerId?, sellerId?, facilityId?) {
    return this.$http.get(`${this.baseUrl}byproduct`, {
      params: {
        agreementId,
        buyerId,
        sellerId,
        facilityId
      }
    });
  }

  byUnspsc(agreementId, buyerId?) {
    return this.$http.get(`${this.baseUrl}byunspsc`, {
      params: {
        agreementId,
        buyerId
      }
    });
  }

  byUnspscMonth(
    contractId,
    bedCategories,
    states,
    systems,
    areAllBedsSelected,
    areAllStatesSelected,
    areAllSystemsSelected
  ): ng.IPromise<AnalyticsByUnspsc> {
    // console.dir(bedCategories);
    // console.dir(states);
    // console.dir(systems);

    // TODO: Check that the values passed in exist in this array
    // let validBedSizes = [
    //   'LESS_THAN_100',
    //   'BETWEEN_100_199',
    //   'BETWEEN_200_299',
    //   'BETWEEN_300_499',
    //   'BETWEEN_500_699',
    //   'MORE_THAN_699'
    // ];

    // If an "all" flag is set to true, there is no need to pass in the list of included items, so just pass in null

    return this.$http.get(`${this.baseUrl}byUnspscMonth`, {
      params: {
        agreementId: contractId,
        bedCategories,
        states,
        systems,
        // bedCategories: areAllBedsSelected ? null : bedCategories,
        // states: areAllStatesSelected ? null : states,
        // systems: areAllSystemsSelected ? null : systems,
        allBeds: areAllBedsSelected,
        allStates: areAllStatesSelected,
        allSystems: areAllSystemsSelected
      }
    });
  }
}
